var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/16/Message Sent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/16/Message-Sent",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1282564,3.43708984 C11.3839897,3.0108676 11.9368239,2.87265904 12.3630462,3.12839238 C12.7564821,3.36445393 12.9045099,3.85366653 12.7238142,4.26276853 L12.6717436,4.3631822 L7.87174363,12.3631822 C7.59058211,12.8317847 6.96826751,12.9373278 6.54992747,12.6127032 L6.4636039,12.5365321 L3.2636039,9.33653212 C2.91213203,8.98506026 2.91213203,8.41521177 3.2636039,8.06373991 C3.58578644,7.74155737 4.091466,7.71470883 4.44423138,7.98319428 L4.5363961,8.06373991 L6.921,10.448136 L11.1282564,3.43708984 Z",
    id: "Style"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSent);
export default __webpack_public_path__ + "static/media/message-sent.a0a187445ebcbabb3292a694105a2bcb.svg";
export { ForwardRef as ReactComponent };